export type OnboardingInsuranceState = {
  hasOtherInsurance: string;
  insuranceProvider: string;
  insurancePolicyNumber: string;
  insuranceExpiryDate: string;
  insurancePremium: string;
  couponCode: string;
  insuranceDocStoreId: string;
};

export type OnboardingInsuranceAction =
  | { type: "SET_HAS_OTHER_INSURANCE"; payload: string }
  | { type: "SET_INSURANCE_PROVIDER"; payload: string }
  | { type: "SET_INSURANCE_POLICY_NUMBER"; payload: string }
  | { type: "SET_INSURANCE_EXPIRY_DATE"; payload: string }
  | { type: "SET_INSURANCE_PREMIUM"; payload: string }
  | { type: "SET_COUPON_CODE"; payload: string }
  | { type: "SET_ALL"; payload: Partial<OnboardingInsuranceState> };

export const onboardingInsuranceInitialState: OnboardingInsuranceState = {
  hasOtherInsurance: "",
  insuranceProvider: "",
  insurancePolicyNumber: "",
  insuranceExpiryDate: "",
  insurancePremium: "",
  couponCode: "",
  insuranceDocStoreId: "",
};

export function onboardingInsuranceReducer(state: OnboardingInsuranceState, action: OnboardingInsuranceAction): OnboardingInsuranceState {
  switch (action.type) {
    case "SET_HAS_OTHER_INSURANCE":
      return { ...state, hasOtherInsurance: action.payload };
    case "SET_INSURANCE_PROVIDER":
      return { ...state, insuranceProvider: action.payload };
    case "SET_INSURANCE_POLICY_NUMBER":
      return { ...state, insurancePolicyNumber: action.payload };
    case "SET_INSURANCE_EXPIRY_DATE":
      return { ...state, insuranceExpiryDate: action.payload };
    case "SET_INSURANCE_PREMIUM":
      return { ...state, insurancePremium: action.payload };
    case "SET_COUPON_CODE":
      return { ...state, couponCode: action.payload };
    case "SET_ALL":
      return { ...state, ...action.payload };
    default:
      console.log(`Error - incorrect action sent ${JSON.stringify(action)} ${JSON.stringify(state)}`);
      return state;
  }
}